import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { setCustomerToken } from "../api";
import { usePageTitle } from "../components/common";

export default function Verify() {
  usePageTitle("Connexion");
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) { setError("Lien invalide."); return; }
    api.post("/auth/verify", { token })
      .then((r) => { setCustomerToken(r.data.access_token); navigate("/espace"); })
      .catch((e) => setError(e?.response?.data?.detail || "Lien invalide ou expiré."));
  }, [token]);

  return (
    <div className="container-x py-28 text-center fade-up">
      {error ? (
        <>
          <p className="text-[#7A5D58]">{error}</p>
          <button onClick={() => navigate("/espace")} className="btn-secondary mt-6">Retour à la connexion</button>
        </>
      ) : (
        <>
          <Loader2 className="animate-spin mx-auto text-[#C9A56A]" size={40} />
          <p className="mt-6 text-[#7A5D58]">Connexion à ton espace…</p>
        </>
      )}
    </div>
  );
}
